import { ReactNode, useId } from 'react'

type Props = {
  title: string
  description?: string
  children: ReactNode
  /** Ações do card (ex.: Salvar). Um botão de submit aqui fora do `<form>` usa a prop `form`. */
  footer?: ReactNode
  className?: string
}

/** Card fixo (sem colapsar) com título, descrição opcional, corpo e rodapé. Para colapsável, `CustomCard`. */
export const SectionCard = ({
  title,
  description,
  children,
  footer,
  className = 'mb-6',
}: Props) => {
  const tituloId = `section_card_${useId()}`

  return (
    <section className={`card ${className}`} aria-labelledby={tituloId}>
      <div className='card-header'>
        <div className='card-title flex-column align-items-start py-4'>
          <h2 id={tituloId} className='fs-4 fw-bold mb-1'>
            {title}
          </h2>
          {description && <p className='text-gray-700 fs-7 mb-0'>{description}</p>}
        </div>
      </div>
      <div className='card-body'>{children}</div>
      {footer && <div className='card-footer d-flex justify-content-end py-4'>{footer}</div>}
    </section>
  )
}
